import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const translations = {
  tr: {
    welcome: 'Hoş Geldiniz',
    viewMenu: 'Menüye Git',
    backToMenu: 'Menüye Dön',
    categories: 'Kategoriler',
    products: 'Ürün',
    popular: 'Popüler',
    spicy: 'Acılı',
    vegan: 'Vegan',
    healthy: 'Sağlıklı',
    signature: 'İmza Ürün',
    allergens: 'Alerjenler',
    price: 'Fiyat',
    currency: '₺',
    openHours: 'Çalışma Saatleri',
    everyDay: 'Her Gün',
    callUs: 'Bizi Arayın',
    followUs: 'Bizi Takip Edin',
    address: 'Adres',
    poweredBy: 'Powered by',
    selectLanguage: 'Dil Seçin',
    turkish: 'Türkçe',
    english: 'English',
    noItems: 'Bu kategoride ürün bulunmamaktadır',
    loading: 'Yükleniyor...',
    exitMenu: 'Menüden Çık',
    allCategories: 'Tüm Kategoriler',
  },
  en: {
    welcome: 'Welcome',
    viewMenu: 'View Menu',
    backToMenu: 'Back to Menu',
    categories: 'Categories',
    products: 'Items',
    popular: 'Popular',
    spicy: 'Spicy',
    vegan: 'Vegan',
    healthy: 'Healthy',
    signature: 'Signature',
    allergens: 'Allergens',
    price: 'Price',
    currency: '₺',
    openHours: 'Opening Hours',
    everyDay: 'Every Day',
    callUs: 'Call Us',
    followUs: 'Follow Us',
    address: 'Address',
    poweredBy: 'Powered by',
    selectLanguage: 'Select Language',
    turkish: 'Türkçe',
    english: 'English',
    noItems: 'No items in this category',
    loading: 'Loading...',
    exitMenu: 'Exit Menu',
    allCategories: 'All Categories',
  },
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('menu-language');
    return saved || 'tr';
  });

  useEffect(() => {
    localStorage.setItem('menu-language', language);
  }, [language]);

  const t = (key) => {
    return translations[language][key] || key;
  };

  const getText = (textObj) => {
    if (!textObj) return '';
    return textObj[language] || textObj.tr || '';
  };

  const toggleLanguage = () => {
    setLanguage((prev) => (prev === 'tr' ? 'en' : 'tr'));
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t, getText, toggleLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
